














import { Vue, Component } from "vue-property-decorator";
import Navbar from "@/modules/home/components/Navbar.vue";
import Sidebar from "@/modules/settings/components/Sidebar.vue";

@Component({
  components: {
    navbar: Navbar,
    sidebar: Sidebar,
  },
})
export default class Settings extends Vue {}
